import gql from "graphql-tag";
import {DOCUMENT_FIELDS} from "./gqlDocumentFields";

// eslint-disable-next-line import/no-default-export
export const GET_DOCUMENTS_BY_ID = gql`
	${DOCUMENT_FIELDS}
	query GetDocuments($id: Int) {
		documents(where: { id: { eq: $id } }) {
			nodes {
				...DocumentFields
			}
		}
	}
`;
